import "../App.css";

function Banner({ message }) {
  return (
    <div className="banner-wrapper">
      <p>{message}</p>
    </div>
  );
}

export default Banner;
